module.exports = "img/flags/MR.b2b167b.png";